export const AUTH_PARAMS = {
  AUTH_TOKEN: 'token',
  LOGIN_CODE: 'login_code',
  REDIRECT_URL: 'redirectUrl',
}

/**
 * Check if the URL contains any authentication parameters.
 * The appraiser frontend uses `?token=` for impersonation logins
 * and `?login_code=` for auth code logins. `login_code` is intentionally
 * distinct from `code`, which the legacy Stripe OAuth callback consumes
 * in Platform.js (see PK-100).
 * @param {string} [searchParams=window.location.search] - URL search parameters
 * @returns {boolean} True if any auth parameters are present
 */
export const hasAuthParams = (searchParams = window.location.search) => {
  const urlParams = new URLSearchParams(searchParams)
  const authToken = urlParams.get(AUTH_PARAMS.AUTH_TOKEN)
  const authCode = urlParams.get(AUTH_PARAMS.LOGIN_CODE)
  return authToken !== null || authCode !== null
}
